import React from 'react';

/**
 * Standard badge/pill atom — theme-safe in light and dark.
 * Variants map to token-soft backgrounds (see theme-overrides.css .lf-badge).
 *
 *   <Badge variant="success">Trained</Badge>
 *   <Badge variant="neutral" icon="fa-crosshairs">Guide</Badge>
 */
const Badge = ({ variant = 'neutral', icon = undefined, children, className = '', title = undefined }) => (
  <span className={`lf-badge lf-badge--${variant} ${className}`.trim()} title={title}>
    {icon && <i className={`fa ${icon}`} aria-hidden="true"></i>}
    {children}
  </span>
);

export default Badge;
